import { SharedTable, SupplierSelect } from '@components';
import { L } from '@lib';
import { PurchaseOrder, PurchaseOrderStatus } from '@services';
import { Input, Select } from 'antd';
import React from 'react';
import { PurchaseOrderColumns } from './PurchaseOrdersTable.columns';

const { Search } = Input;

interface IProps {
  items: PurchaseOrder[];
  total: number;
  loading: boolean;
  currentPage: number;
  maxResultCount: number;
  headerActions: React.ReactNode;
  onPageChange: (pagination: any) => void;
  onSearch: (value: string) => void;
  onStatusFilter: (value: string | undefined) => void;
  onSupplierFilter: (value: string | undefined) => void;
  onEdit: (item: PurchaseOrder) => void;
  onMarkOrdered: (item: PurchaseOrder) => void;
  onReceive: (item: PurchaseOrder) => void;
  onCancel: (item: PurchaseOrder) => void;
}

export const PurchaseOrdersTablePresentation: React.FC<IProps> = ({
  items,
  total,
  loading,
  currentPage,
  maxResultCount,
  headerActions,
  onPageChange,
  onSearch,
  onStatusFilter,
  onSupplierFilter,
  onEdit,
  onMarkOrdered,
  onReceive,
  onCancel,
}) => (
  <div style={{ width: '100%' }}>
    <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
      <Search
        placeholder={L('Search part, reg, VIN, build...')}
        allowClear
        style={{ width: 260 }}
        onSearch={onSearch}
      />
      <Select
        allowClear
        placeholder={L('Filter by status')}
        style={{ width: 160 }}
        onChange={onStatusFilter}
        options={[
          { label: 'Draft', value: PurchaseOrderStatus.Draft },
          { label: 'Ordered', value: PurchaseOrderStatus.Ordered },
          { label: 'Received', value: PurchaseOrderStatus.Received },
          { label: 'Canceled', value: PurchaseOrderStatus.Canceled },
        ]}
      />
      <SupplierSelect
        placeholder={L('Filter by supplier')}
        allowClear
        style={{ width: 200 }}
        onChange={onSupplierFilter}
      />
    </div>

    <SharedTable
      loading={loading}
      dataSource={items}
      totalCount={total}
      currentPage={currentPage}
      maxResultCount={maxResultCount}
      handlePageChange={onPageChange}
      enableRowClick
      onRowClick={onEdit}
      columns={PurchaseOrderColumns({ onEdit, onMarkOrdered, onReceive, onCancel })}
      headerActions={headerActions}
      scrollX={undefined}
    />
  </div>
);
